import React, { useEffect,    useState } from "react";
import ActivityCard from "./ActivityCard";
import { Activity } from "./types";
import { useIsMobile } from "@/hooks/use-mobile";
import { useFeatureFlagStatus } from "@/utils/FeatureFlagProvider";
import { getAdSenseConfig } from '@/constants/adsense';
import { useLocation } from "react-router-dom";
import { useSpaSafeShowAd } from "@/hooks/useSpaSafeShowAd";
import AdSenseWrapper from "../ads/AdSenseWrapper";
import { GoogleAdsScriptLoader } from "../ads/GoogleAdsScriptLoader";

interface ActivityListProps {
  activities: Activity[];
  title?: string;
  isLoading?: boolean;
}

const ActivityList = ({ activities, title, isLoading }: ActivityListProps) => {
  const location = useLocation();

  const isMobile = useIsMobile();
  const { publisherId, slotId } = getAdSenseConfig(isMobile ? '350_250_Responsive_ActivityList' : '728_90_ActivityList');
  const minHeight = isMobile ? '250px' : '90px';

  const [hasInitialized, setHasInitialized] = useState(false);
  const [showAd, setShowAd] = useSpaSafeShowAd(location.pathname);
  const { googleAds: googleAdsEnabled } = useFeatureFlagStatus(); // Use boolean flag


  useEffect(() => {
      if (isLoading || hasInitialized) return;     
      console.log("ActivityList: Google Ads enabled:", googleAdsEnabled);    
      setHasInitialized(true);
    
  }, [isLoading, hasInitialized, activities.length, googleAdsEnabled]);
     
  if (isLoading) {
    return (
      <div className="py-8 text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto" />
        <p className="mt-2 text-sm text-muted-foreground">Loading activities...</p>
      </div>
    );
  }

  console.log("ActivityList: isLoading", isLoading , "activities", activities?.length);

  if (activities.length === 0) {
    return (
      <div className="py-8 text-center text-muted-foreground">
        <p>No activities found. Try adjusting your search or filters.</p>
      </div>
    );
  }

  console.log("ActivityList: googleAdsEnabled", googleAdsEnabled);
  console.log("ActivityList: showAdd", showAd);

  return (
    <>
      <GoogleAdsScriptLoader enabled={googleAdsEnabled} publisherId={publisherId} />
      <div className="space-y-4">
        {title && <h3 className="text-lg font-semibold my-6">{title}</h3>}

        <div className="space-y-4">
          {activities.map((activity, index) => (
            <div key={activity.id} className="w-full">
              <div className="activity-card-container">
                <ActivityCard
                  title={activity.name}
                  description={activity.description}
                  imageUrl={activity.thumbnailUrl}
                  imageUrls={activity.imageUrls}
                  price={`${activity.minPrice}`}
                  currency={activity.currency}
                  bookingUrl={activity.url}
                  rating={activity.ratingAverage}
                  numberOfRatings={activity.numberOfRatings}
                />

                {/* Show ad after the first activity */}
                {index === 0 && showAd && googleAdsEnabled === true && (
                  <div
                    className="activity-list-ad"
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      minHeight: minHeight,
                      minWidth: 0,
                      display: 'block',
                      margin: '16px auto 32px auto', // center horizontally
                      overflow: 'hidden',
                      boxSizing: 'border-box',
                    }}
                  >
                    <AdSenseWrapper
                      style={{
                        width: '100%',
                        maxWidth: '100%',
                        display: 'block',
                        overflow: 'hidden',
                        objectFit: 'contain', // extra safety for ad content
                        boxSizing: 'border-box',
                      }}
                      slot={slotId}
                      publisherId={publisherId}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ActivityList;
